import { render, staticRenderFns } from "./LessonFormNew.vue?vue&type=template&id=9ecdb258&scoped=true"
import script from "./LessonFormNew.vue?vue&type=script&lang=js"
export * from "./LessonFormNew.vue?vue&type=script&lang=js"
import style0 from "./LessonFormNew.vue?vue&type=style&index=0&id=9ecdb258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecdb258",
  null
  
)

export default component.exports